<script setup>
import {originalCountries} from '~/assets/jsons/originalParams.json';
import { legalSystemInfo } from '~/assets/jsons/contents/pages/profession/country.json';



const route = useRoute();
const { country } = route.params;

const originalCountry = originalCountries[country];
const currentCountry = legalSystemInfo[originalCountry];


// Her bir kaynak türü için uygun ikon seçimi
const getIconForSource = (source) => {
  const iconMap = {
    'laws': 'pi-file-pdf',
    'executiveDecisions': 'pi-bookmark',
    'regulations': 'pi-book',
    'announcements': 'pi-bell',
    'internationalAgreements': 'pi-globe',
    'supremeCourtDecisions': 'pi-list',
    'officialGazetteArchive': 'pi-folder',
    'judicialDecisions': 'pi-briefcase',
    'constitution': 'pi-shield',
    'legislation': 'pi-file',
    'decrees': 'pi-flag',
    'ministerialDecisions': 'pi-id-card',
    'shariaLaw': 'pi-book',
    'judicialRulings': 'pi-list'
  };
  
  return iconMap[source] || 'pi-file-pdf';
};


</script>

<template>
    <section class="py-16 md:py-24 bg-[var(--p-background-ground)]">
      <div class="container mx-auto px-4">
        <h2
        data-aos="fade-up"
        class="text-3xl font-bold text-center mb-4 text-[var(--p-primary-800)]">{{ $t('pages.profession.legalSystemOverview') }}</h2>
        <p
        data-aos="fade-up"
        class="text-center text-[var(--p-text-secondary-color)] mb-12 max-w-3xl mx-auto">
          {{ $t(`lawyerCountries.${originalCountry}.keyFeaturesOf`) }}
        </p>
        
        <!-- Hukuki Kaynaklar -->
        <div class="bg-[var(--p-background-card)] rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
          <div class="flex justify-between items-center mb-6">
            <h3
            data-aos="fade-up"
            class="text-2xl font-semibold text-[var(--p-primary-800)]">{{ $t(`lawyerCountries.${originalCountry}.statistics.title`) }}</h3>
            <i
            data-aos="fade-up"
            class="pi pi-book text-3xl text-[var(--p-primary-600)]"></i>
          </div>
          <p
          data-aos="fade-up"
          class="mb-6 text-[var(--p-text-secondary-color)]">
            {{ $t(`lawyerCountries.${originalCountry}.statistics.description`) }}
          </p>
          <PrimeDivider />
          
          <div class="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div 
              v-for="(source, index) in currentCountry.sources" 
              :key="index" 
              class="p-4 rounded-lg hover:shadow-md transition-shadow"
            >
              <div
              data-aos="fade-up"
              class="flex items-start">
                <div
                class="min-w-10 h-10 rounded-full flex items-center justify-center bg-[var(--p-primary-100)] mr-4">
                  <i :class="`pi ${getIconForSource(source)} text-[var(--p-primary-600)]`"></i>
                </div>
                <div>
                  <h4
                  class="font-semibold text-[var(--p-primary-700)] mb-2">
                    {{ $t(`lawyerCountries.${originalCountry}.statistics.${source}`) }}
                  </h4>
                  <p
                  
                  class="text-sm text-[var(--p-text-secondary-color)]">
                    {{ $t(`lawyerCountries.${originalCountry}.statistics.sources.${source}`) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="mt-8 p-4 bg-[var(--p-primary-50)] rounded-lg border border-[var(--p-primary-100)]">
            <p
            data-aos="fade-up"
            class="text-[var(--p-primary-800)] text-center">
              {{ $t(`lawyerCountries.${originalCountry}.statistics.statistics`) }}
            </p>
          </div>
        </div>
      </div>
    </section>
</template>

<style scoped>
/* Hover efekti */
.border:hover {
  border-color: var(--p-primary-300);
}
</style>